import { QUERY_KEYS } from 'api/query-keys';
import { sharedPaymentService } from 'api/services';
import { useInfiniteQuery } from 'react-query';
import { Site } from 'shared/hooks';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';
import { PaymentsFilters } from './use-payments-filters.types';

export const useGetPayments = (site: Site, filters: PaymentsFilters) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.paymentsWithFilters(filters),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedPaymentService.getPaginatedPayments(site, {
        ...filters,
        page: pageParam,
        pageSize: DEFAULT_PAGE_SIZE,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
